<template>
  <div id="app">
    <p v-if="middleware.msg">{{middleware.msg}}</p>
    <ts-iclass-layout v-else :style="{visibility: visible}" @jump-home="jumpHome" :navs="navs" :network="network" @set-navigator="setNavigator">
      <simple-navigation v-if="isPC && $route.meta.simple" :title="$route.meta.title"></simple-navigation>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </ts-iclass-layout>
  </div>
</template>

<script>
import SimpleNavigation from "@/views/components/SimpleNavigation";
import { setBodyClass, browserPC } from "../../utils/screen";
import { getRequest, putRequest, postJsonRequest, postRequest } from '@/utils/http'

export default {
  name: "app",
  components: { SimpleNavigation },
  data() {
    return {
      isPC: false,
      middleware: { msg: 'e课堂加载中...' },
      network: { getRequest: null },
      visible: 'visible', // 选择是否在路由启动后展示页面
      navs: ['header', 'aside', 'back-top', 'footer']
    };
  },
  created() {
    let href = self.location.href
    // 解析网校通页面高度
    if (href.indexOf('/wxt/agentsetting') !== -1) {
      let parent_document = parent.parent.document
      const height = parseInt(href.split("&h=")[1]) + 'px'
      parent_document.getElementById('iframe_wxt').style.height = height
      this.middleware.msg = 'e课堂已解析网校通页面高度 - ' + height
    } else {
      this.isPC = browserPC()
      this.network = { getRequest, putRequest, postJsonRequest, postRequest }
      this.middleware.msg = null // 开始初始化e课堂
      setBodyClass("app") // 打上浏览器类型标签
    }
  },
  methods: {
    jumpHome: function (info) {
      console.log('jumpHome', info)
      this.$store.commit('setBigUser', info.bigUser)
      this.$store.commit('login', info.user)
      if (this.isPC) {
        this.recoverRoute()
        if (this.$route.meta.simple) {
          this.navs = ['back-top', 'footer']
        } else {
          if (info.type === 'student') {
            this.navs = ['header', 'back-top', 'footer']
          } else {
            this.navs = ['header', 'aside', 'back-top', 'footer']
          }
          const url = info.source.url
          const pass = location.href.indexOf('zjcusp=') !== -1 || location.href.indexOf('/wxt/agentsetting') !== -1 || location.href.indexOf('zjdsal=1') !== -1 || location.href.indexOf('/zjw') !== -1
          if (!pass) {
            if (location.href.indexOf('wxtpath') !== -1) {
              // 更新地址栏的为网校通首页
              if (history.replaceState) {
                let state = { title: document.title, url: document.location.href, otherkey: null }
                history.replaceState(state, document.title, url)
              }
              return
            }
            if (process.env.NODE_ENV === 'development') {
              location.href = '#/teacher-home'
            } else if (location.href !== url) {
              if (url.indexOf(location.pathname) !== -1) {
                const routeName = this.$route.name
                if ('WpsEdit'.indexOf(routeName) < 0 ) {
                  location.href = url
                  if (document.body.className.indexOf('ie-browser') !== -1) {
                    location.reload()
                  }
                }
              } 
              else {
                window.open(url, info.source.target)
              }
            }
          }
        }
      } else {
        this.navs = []
      }
      this.visible = 'visible'
    },
    setNavigator: function (navigator) {
      // 直播购买提示
      if (navigator.url.includes('live') && !navigator.alreadyBuy) {
        navigator.callback = () => {
          if (navigator.url.includes('spaceType=1')) { // 教师
            let host = window.location.host
            let protocol = window.location.protocol
            let url = protocol + '//' + host + '/live/#/introduce?spaceType=1'
            window.open(url, '_self')
          } else if (navigator.url.includes('spaceType=2')) { // 管理员
            let host = window.location.host
            let protocol = window.location.protocol
            let url = protocol + '//' + host + '/live/#/introduce?spaceType=2'
            window.open(url, '_self')
          } else { // 学生
            this.$message.error('您暂未购买此服务，可联系010-56273901咨询购买。')
          }
        }
      }
    },
    recoverRoute: function () {
      setTimeout(() => {
        let url = localStorage.getItem("jump-url-after-login");
        if (url && url.length > 0) {
          localStorage.removeItem("jump-url-after-login");
          window.open(url, "_self");
        }
      }, 1 * 1000);
    }
  }
};
</script>

<style>
@import "../../assets/styles/reset.css";
@import "../../assets/styles/style.css";
@import "../../assets/iconfont/iconfont.css";
@import "../../assets/styles/ie-browser.css";
@import "../../../node_modules/teaching-ui/dist/index.css";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f5f5f5;
  height: 100%;
}
</style>
